import { Action } from "redux";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["RESET_STORE"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type ResetStore = ActionBase<"RESET_STORE">;

export type StoreAction = ResetStore;

export const isStoreAction = (action: Action): action is StoreAction =>
  isActionType(action, ActionTypeKeys);

/**
 * Reset the store, but leave the properties which wouldn’t change on a revision revert
 */
export const resetStore = (): ResetStore => ({ type: "RESET_STORE" });
